import { useState, useEffect } from "react";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

// react-router components
import { Link, useNavigate } from "react-router-dom";

//Material UI Components

// MUI icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import MainNavigation from "../components/common/MainNavigation";
import Loader from "../components/common/Loader";
import FilterAcrossProductsToggleComponent from "../components/common/FilterAcrossProductsToggleComponent";
import WeightToggleComponent from "../components/common/WeightToggleComponent";
import Reset from "../components/common/Reset";
import TTestDialog from "../components/common/TTest/TTestDialog";
import BeautyAndWellbeingTTestDialog from "components/common/TTest/BeautyAndWellbeingTTestDialog";
import AnalysisTable from "../components/common/analysisModule/AnalysisTable";
import AnalysisChart from "../components/common/analysisModule/chart/AnalysisChart";
import ViewToggle from "../components/common/ViewToggle";
import InitialPopup from "../components/common/InitialPopup";
import AnalysisTypeSelector from "../components/common/AnalysisTypeSelector";
import AbsoluteCounts from "../components/common/analysisModule/AbsoluteCounts";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadClaimsAnalysisResultState,
    loadIsClaimsAnalysisResultLoadingState,
    loadJustRightAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
    loadIsJustRightAnalysisResultLoadingState,
    loadAgreementAnalysisResultState,
    loadIsAgreementAnalysisResultLoadingState,
    loadOverallAnalysisResultState,
    loadIsOverallAnalysisResultLoadingState,
    loadSecondaryAnalysisResultState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsItmDataState,
    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
} from "store/features/analysisResultsSlice";
import { resetTTestStore } from "store/features/ttestSlice";

import { loadClaimsRemovedKpiListState } from "store/features/analysisKpiSlice";
import { showNotification } from "store/features/notificationSlice";

// utils - api's
import GetAgreementResult from "../utils/apis/GetAgreementResult";
import GetOverallResult from "../utils/apis/GetOverallResult";
import GetSecondaryResult from "../utils/apis/GetSecondaryResult";
import GetClaimsResult from "../utils/apis/GetClaimsResult";
import GetJustRightResult from "../utils/apis/GetJustRightResult";

function ClaimsAnalysis({ headerTitle = "" }) {
    const navigate = useNavigate();

    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.claimsAnalysisResult);
    const isLoading = useSelector((state) => state.analysisResultsStore.isClaimsAnalysisResultLoading);
    const claimsTerritorySelectedTags = useSelector((state) => state.claimsAnalysisStore.claimsAnalysisSelectedTagsFilter);
    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);

    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);

    // Analysis type
    const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.claimsAnalysisTypeValue);
    const boxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisTypeSelection);
    const [column2, setColumn2] = useState([]);
    const [isTableShown, setIsTableShown] = useState(true);

    const [dataMappingData, setDataMappingData] = useState([]);
    const [isDataMappingDataLoading, setIsDataMappingDataLoading] = useState(false);

    // snackbar

    const [claimsBackendVariableStudyDriven, setClaimsBackendVariableStudyDriven] = useState([]);
    const [claimsTerritoryTags, setClaimsTerritoryTags] = useState([]);

    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
    });

    // for T-Test
    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");
    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);

    // Analysis type
    const claimsAnalysisType = useSelector((state) => state.analysisTypeSelectionStore.claimsAnalysisTypeValue);

    // const [tTestPerformed, setTTestPerformed] = useState(false);
    // const [confidenceInterval, setConfidenceInterval] = useState("");
    // const [tTestType, setTTestType] = useState("");
    // const [tTestProducts, setTTestProducts] = useState("");
    // const [tTestCoreDataId, setTTestCoreDataId] = useState(0);
    // const [tTestAnalysisType, setTTestAnalysisType] = useState("");

    // const removedList = useSelector((state) => state.analysisKpiStore.claimsRemovedKpiList);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const jarOrJustRightVariableCategory = isHairCare || isSkinCare ? "JAR" : "Just Right";
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const btnArr = isOralCare || isSkinCleansing || isHairCare || isSkinCare ? ["overallKpi", "justRight", "agreementKpi", "correlation"] : ["overallKpi", "agreementKpi", "correlation"];

    useEffect(() => {
        let _array = productsSecondaryDataState.map((datum) => {
            const _scoreBv = datum.scores.map((ele) => {
                return ele.backendVariable;
            });
            return _scoreBv;
        });

        _array = Array.from(new Set(_array.flat()));
        const array = _array.map((ele) => {
            return {
                backendVariable: ele,
                tags: column2?.["claim_tag_map"]?.[ele].sort() || [],
                statement: column2?.["claim_backend_variable_map"]?.[ele] || "",
            };
        });

        let _tags = array.map((ele) => {
            return ele?.tags || [];
        });
        _tags = Array.from(new Set(_tags.flat()));

        // filter productsSecondaryData based on tags
        if (claimsTerritorySelectedTags.length !== 0) {
            const filteredData = array.filter((item) => item.tags.some((tag) => claimsTerritorySelectedTags.includes(tag)));

            setClaimsBackendVariableStudyDriven([...filteredData]);
        } else {
            setClaimsBackendVariableStudyDriven([...array]); // default state
        }
        setClaimsTerritoryTags([..._tags]);
    }, [productsSecondaryDataState, claimsTerritorySelectedTags, column2]);

    const clearResult = () => {
        setTTestResult([]);
        setTestLabel("");
        dispatch(resetTTestStore());

        // setTTestPerformed(false);
        // setConfidenceInterval("");
        // setTTestType("");
        // setTTestProducts("");
        // setTTestCoreDataId(null);
    };

    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading]);

    // Clear the removed KPI data from the Redux store on page change to reset the default view.
    // Remove the code below if you want to retain the removed variables.
    useEffect(() => {
        return () => {
            dispatch(loadClaimsRemovedKpiListState([]));
        };
    }, [dispatch]);

    const clearTtest = (product, type) => {
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };

    const getClaimsResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        clearTtest(product, type);

        dispatch(loadIsClaimsAnalysisResultLoadingState(true));
        dispatch(loadIsAgreementAnalysisResultLoadingState(true));
        dispatch(loadIsOverallAnalysisResultLoadingState(true));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(true));

        const claimsResult = await GetClaimsResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.claimsAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["claims"] });

        if (claimsResult?.length > 0) {
            await dispatch(loadClaimsAnalysisResultState([...claimsResult]));
            if (!type) {
                dispatch(loadDefaultClaimsAnalysisResultState([...claimsResult]));
            }
            // Validate the claims data after fetching

            // const isValid = ValidateEmptyGroupResponse(claimsResult);
            // Check if at least one study has valid claims data
            const hasValidClaimsData = claimsResult.some((result) => result.scores.length > 0);
            if (!hasValidClaimsData) {
                handleError("warning", "Claims data is not valid for the selected studies.");
            }
        }
        dispatch(loadIsClaimsAnalysisResultLoadingState(false));

        const overallResult = await GetOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.overallAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["overall"] });
        if (overallResult) {
            overallResult.forEach((product) => {
                product.scores.forEach((ele) => {
                    if (ele.backendVariable.includes("ITM_") && ele.mean) {
                        dispatch(loadIsItmDataState(true));
                    }
                });
            });
            dispatch(loadOverallAnalysisResultState([...overallResult]));
            if (!type) {
                dispatch(loadDefaultOverallAnalysisResultState([...overallResult]));
            }
        }

        const secondaryResult = await GetSecondaryResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.secondaryAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["secondary"] });
        if (secondaryResult) {
            dispatch(loadSecondaryAnalysisResultState([...secondaryResult]));
            if (!type) {
                dispatch(loadDefaultSecondaryAnalysisResultState([...secondaryResult]));
            }
        }

        const agreementResult = await GetAgreementResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.agreementAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["agreement"] });
        if (agreementResult) {
            await dispatch(loadAgreementAnalysisResultState([...agreementResult]));
            if (!type) {
                dispatch(loadDefaultAgreementAnalysisResultState([...agreementResult]));
            }
        }

        if (!isDeodorants) {
            dispatch(loadIsJustRightAnalysisResultLoadingState(true));
            const justRightResult = await GetJustRightResult(product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData?.justRightAnalysisResult || [], productsOrder, productCategoryId, jarOrJustRightVariableCategory);
            dispatch(loadJustRightAnalysisResultState([...justRightResult]));
            if (!type) {
                dispatch(loadDefaultJustRightAnalysisResultState([...justRightResult]));
            }
            dispatch(loadIsJustRightAnalysisResultLoadingState(false));
        }

        console.log("fetchOnlyCurrent", fetchOnlyCurrent);

        dispatch(loadIsOverallAnalysisResultLoadingState(false));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(false));
        dispatch(loadIsAgreementAnalysisResultLoadingState(false));
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };

    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;

        if (isOralCare) {
            disabled = false;
        } else {
            _selectedStudies.forEach((each) => {
                if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                    disabled = false;
                } else {
                    disabled = true;
                }
            });
        }

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy, isOralCare]);

    useEffect(() => {
        async function fetchDataMappingData() {
            try {
                let url = process.env.REACT_APP_SERVER_PATH + `/claims-mappings/claims-tags-mapping/`;
                if (productCategoryId) {
                    url += `?product_category=${productCategoryId}`;
                }
                setIsDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then(async (res) => {
                        setDataMappingData(res.data);
                        const _column2 = res.data;
                        setColumn2(_column2);
                        setIsDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsDataMappingDataLoading(false);
            }
        }
        async function fetchAnalysisResult() {
            if (!productsSecondaryDataState.length) {
                await getClaimsResult({
                    product: null,
                    coreDataId: null,
                    type: null,
                    consumerFilter: null,
                    pcs: [],
                    selectedStudy,
                    allAnalysisData: [],
                    fetchOnlyCurrent: true,
                    boxAnalysisSelection: {
                        overall: overallBoxAnalysisSelection,
                        secondary: secondaryBoxAnalysisSelection,
                        agreement: agreementBoxAnalysisSelection,
                        claims: claimsBoxAnalysisSelection,
                    },
                });
            }
        }

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchAnalysisResult();
            fetchDataMappingData();
        }
    }, [selectedStudy, productCategoryId]);

    // const onTTestDataReceived = (tTest, tTestConfidenceInterval, testType, testProducts, tTestCoreDataId, tTestAnalysisType) => {
    //     setTTestPerformed(tTest);
    //     setConfidenceInterval(tTestConfidenceInterval);
    //     setTTestType(testType);
    //     setTTestProducts(testProducts);
    //     setTTestCoreDataId(tTestCoreDataId);
    //     setTTestAnalysisType(tTestAnalysisType);
    // };

    return (
        <>
            {(isLoading || isDataMappingDataLoading) && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
            // tTestPerformed={tTestPerformed}
            // confidenceInterval={confidenceInterval}
            // tTestType={tTestType}
            // tTestProducts={tTestProducts}
            // tTestCoreDataId={tTestCoreDataId}
            // tTestAnalysisType={tTestAnalysisType}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>
            <div
                style={{
                    minHeight: "calc(100vh - 180px)",
                }}
                className="full-container m-4 background-color-white  box-shadow--full-container"
            >
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 1,
                    }}
                >
                    <Link
                        to="/studies"
                        onClick={(e) => {
                            if (window.history.length > 2) {
                                e.preventDefault();
                                navigate(-1);
                            }
                        }}
                    >
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -15,
                                left: -15,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>
                <div
                    className="card-btns"
                    style={{ padding: "20px 20px 20px 20px" }}
                >
                    <div
                        style={{
                            display: "flex",
                            zIndex: 9,
                        }}
                    >
                        <div
                            style={{
                                marginBottom: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <ViewToggle
                                value={isTableShown}
                                setValue={setIsTableShown}
                                labels={["Table", "Chart"]}
                            />
                        </div>
                        <div
                            style={{
                                marginLeft: "1rem",
                                width: "150px",
                                zIndex: "3",
                            }}
                        >
                            <AnalysisTypeSelector
                                value={claimsAnalysisType}
                                pageName="claimsAnalysis"
                                variableCategory="Claim"
                                handleFilterSubmit={getClaimsResult}
                                mappings={[dataMappingData.claim_tag_map]}
                                moduleName="claims"
                                clearResult={clearResult}
                            />
                        </div>
                        {analysisTypeValue?.value === "box_analysis" && isOralCare &&
                            <AbsoluteCounts
                                moduleName="agreement"
                            />
                        }
                    </div>
                    <div>
                        <WeightToggleComponent />
                        <FilterAcrossProductsToggleComponent />
                        {isBeautyAndWellbeing ? (
                            <BeautyAndWellbeingTTestDialog
                                variableCategory="Claim"
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "claims",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: claimsBoxAnalysisSelection,
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        ) : (
                            <TTestDialog
                                variableCategory="Claim"
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "claims",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: claimsBoxAnalysisSelection,
                                    mappings: claimsBackendVariableStudyDriven,
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        )}
                        <Reset clearTTestResult={clearResult} />
                    </div>
                </div>
                {productsSecondaryDataState.length !== 0 && dataMappingData.length !== 0 && (
                    <div
                        style={{
                            minHeight: "calc(100vh - 300px)",
                            padding: "20px",
                        }}
                    >
                        {isTableShown ? (
                            <>
                                <AnalysisTable
                                    productsSecondaryData={productsSecondaryDataState}
                                    handleFilterSubmit={getClaimsResult}
                                    selectedStudy={selectedStudy}
                                    analysisLevelData={{
                                        tableConfig: {
                                            stickyColumns: ["Claims Territory tag(s)", "Claim statements"],
                                        },
                                        moduleName: "claims",
                                        analysisTypeValue: analysisTypeValue,
                                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                        boxAnalysisSelection: claimsBoxAnalysisSelection,
                                        mappings: claimsBackendVariableStudyDriven,
                                        // claimsBackendVariableStudyDriven: claimsBackendVariableStudyDriven,
                                        claimsTerritoryTags: claimsTerritoryTags,
                                        claimsTerritorySelectedTags: claimsTerritorySelectedTags,
                                        // analysisTypeValue: analysisTypeValue,
                                    }}
                                    tTest={{
                                        tTestLegends: legends,
                                        isFisher: isFisher,
                                        tTestResult: tTestResult,
                                        testLabel: testLabel,
                                    }}
                                />
                                {/* <ComparisonTable
                                    selectedStudy={selectedStudy}
                                    // productsRow={productsRow}
                                    productsSecondaryData={productsSecondaryDataState}
                                    dataMappingData={dataMappingData}
                                    // activeMacroCategory={activeMacroCategory}
                                    // column1={column1}
                                    column2={column2}
                                    tTestResult={tTestResult}
                                    // keyMapDisplayLabelConsumerFilter={keyMapDisplayLabelConsumerFilter}
                                    testLabel={testLabel}
                                    handleFilterSubmit={getClaimsResult}
                                    claimsTerritoryTags={claimsTerritoryTags}
                                    claimsBackendVariableStudyDriven={claimsBackendVariableStudyDriven}
                                /> */}
                            </>
                        ) : (
                            <AnalysisChart
                                productsSecondaryData={productsSecondaryDataState}
                                analysisLevelData={{
                                    moduleName: "claims",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: claimsBoxAnalysisSelection,
                                    mappings: claimsBackendVariableStudyDriven, // only study driven
                                    // claimsBackendVariableStudyDriven: claimsBackendVariableStudyDriven,
                                }}
                                tTest={{
                                    tTestLegends: legends,
                                    isFisher: isFisher,
                                    tTestResult: tTestResult,
                                    testLabel: testLabel,
                                }}
                            />
                            // <AnalysisChart
                            //     selectedStudy={selectedStudy}
                            //     // productsRow={productsRow}
                            //     productsSecondaryData={productsSecondaryDataState}
                            //     dataMappingData={dataMappingData}
                            //     //activeMacroCategory={activeMacroCategory}
                            //     column2={column2}
                            //     tTestResult={tTestResult}
                            //     chartType={chartType}
                            //     analysisType={"claimsAnalysis"}
                            //     colorsType={"claimsAnalysis"}
                            //     legends={legends}
                            //     componentName={"claimsAnalysisDataState"}
                            //     pageName={"claimsAnalysis"}
                            //     testLabel={testLabel}
                            //     dataView={isDeodorants ? top2BoxToggle : dataView}
                            //     claimsTerritoryTags={claimsTerritoryTags}
                            //     claimsBackendVariableStudyDriven={claimsBackendVariableStudyDriven}
                            //     removedList={removedList}
                            // />
                        )}
                        {/* <p
                            style={{
                                textAlign: "right",
                                marginRight: "12px",
                                transform: "skew(170deg)",
                                // marginBottom: "32px",
                            }}
                        >
                            Agreement Likert scale size is indicated in brackets () next to each variable
                        </p> */}
                    </div>
                )}
                <div
                    style={{
                        position: "relative",
                        top: "5px",
                        width: "100%",
                        margin: "auto",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        btnDisabledObj={btnDisabled}
                    />
                </div>
            </div>
        </>
    );
}

// Typechecking props for the ClaimsAnalysis
ClaimsAnalysis.propTypes = {
    headerTitle: PropTypes.string,
};

export default ClaimsAnalysis;
